// TODO: Patron Redux en revisión de cargos en proceso
import React from "react";
import { Container, FormGroup, FormText, Label, TabPane } from "reactstrap";
import { PARTNER_MEMB_ACTIVE_STATUS } from "../../../../utils/constants";
import { Partner } from "../interfaces";

interface Props {
  partner: Partner;
}

class TabActivated extends React.Component<Props> {
  isMembershipActiva = () => {
    return (
      !!this.props.partner &&
      [PARTNER_MEMB_ACTIVE_STATUS].includes(this.props.partner.estatusMembresia)
    );
  };

  render() {
    return (
      <TabPane className="my-2" tabId="4">
        <Container className="p-0 m-0">
          {this.isMembershipActiva() && (
            <div className="m-4">
              <FormGroup>
                <Label style={{ fontWeight: "bold" }}>
                  Gracias por tu compra
                </Label>
                <FormText color="muted">
                  Has completado la activación de tu membresía
                </FormText>
              </FormGroup>
            </div>
          )}
        </Container>
      </TabPane>
    );
  }
}

export default TabActivated;
